var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-center"},_vm._l((_vm.list),function(name,key){return _c('div',{key:key,staticClass:"btn btn-link ml-3"},[(_vm.activeKey == key)?_c('span',[_vm._v(_vm._s(name))]):_c('router-link',{attrs:{"to":`/data/ai/${key}/`}},[_vm._v(_vm._s(name))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }